(function (angular) {
  "use strict";

  var TOOLBAR_HEIGHT_PX = 55;

  angular.module("Toyota.Directives").directive("tyPricingPageUi", [
    "CssMediaWatcher",
    "$window",
    function (CssMediaWatcher, $window) {
      var link = function ($scope, $element) {
        $scope.pricingPage.stickyFooterVisible = false;

        var $infoSection = $element.find('[data-js="ty-pricing-page-info-panel"]');
        var $selectSection = $element.find('[data-js="ty-pricing-page-select-panel"]');
        var infoTopOffsetDistance = 72;
        var isSafariIOS = /iP(hone|od|ad).+Version\/[\d.]+.*Safari/i.test(navigator.userAgent);

        var $driveawayPricing = $element.find('[data-js="ty-pricing-page-info-panel-driveaway"]');
        var $stickyFooter = $element.find('[data-js="ty-pricing-page-sticky-footer"]');
        var $pricingPageContainer = angular.element(".ty-pricing-page__body");
        var stickyFooterInitialHeight = $stickyFooter.outerHeight();
        var footerStaticClass = "is-footer-static";
        var footerLandscapeClass = "is-ios-landscape";

        var cssMediaWatcher = CssMediaWatcher({
          $el: $element,
          pseudoEl: "before",
          mediaProperty: "viewportWidth",
          mediaRegexes: {
            mobile: "^mobile$",
            desktop: "^desktop$",
          },
        });

        var updateStickyInfo = function () {
          var selectSectionViewportPosition = $selectSection[0].getBoundingClientRect().top;
          var selectSectionViewportPositionBottom = $selectSection[0].getBoundingClientRect().bottom;
          var sectionHeightsDiff = $selectSection.outerHeight() - $infoSection.outerHeight();
          var maxTravelDistance = sectionHeightsDiff > 0 ? sectionHeightsDiff : 0;
          var viewportWidth = cssMediaWatcher.getCurrentMedia().viewportWidth;

          if (selectSectionViewportPosition > infoTopOffsetDistance || viewportWidth.is.mobile) {
            $infoSection.css("margin-top", "").css("position", "").css("top", "");
          } else if (selectSectionViewportPositionBottom < $infoSection.outerHeight() + infoTopOffsetDistance) {
            $infoSection.css("margin-top", maxTravelDistance).css("position", "").css("top", "");
          } else {
            $infoSection.css("margin-top", "").css("position", "fixed").css("top", infoTopOffsetDistance);
          }
        };

        var updateStickyFooter = function () {
          var pricingPageViewportPosition = $element[0].getBoundingClientRect().top;
          var pricingPageViewportBottom = $element[0].getBoundingClientRect().bottom;
          var pricingPageViewportPositionFromBottom = $window.innerHeight - pricingPageViewportPosition;
          var driveawayPricingClientRect = $driveawayPricing[0].getBoundingClientRect();
          var driveawayPricingViewportPositionMidpoint =
            (driveawayPricingClientRect.top + driveawayPricingClientRect.bottom) / 2;
          var driveawayPricingViewportPositionMidpointFromBottom =
            $window.innerHeight - driveawayPricingViewportPositionMidpoint;
          var viewportWidth = cssMediaWatcher.getCurrentMedia().viewportWidth;

          if (!viewportWidth.is.mobile) {
            if (pricingPageViewportBottom > $window.innerHeight) {
              $pricingPageContainer.removeClass(footerStaticClass);
            } else {
              $pricingPageContainer.addClass(footerStaticClass);
            }
          } else if (
            pricingPageViewportPositionFromBottom > stickyFooterInitialHeight &&
            driveawayPricingViewportPositionMidpointFromBottom < 0
          ) {
            $scope.pricingPage.stickyFooterVisible = true;
            $stickyFooter.show().addClass("is-footer-visible");
          } else {
            $scope.pricingPage.stickyFooterVisible = false;
            $stickyFooter.removeClass("is-footer-visible");
          }
        };

        var adjustStickyFooterForIOS = function () {
          // If the footer is offset (i.e. hidden) or we're not in Safari IOS then we don't want to modify the styles
          if (!$scope.pricingPage.stickyFooterVisible || !isSafariIOS) {
            return;
          }

          // Landscape mode = $window.innerHeight < $window.innerWidth
          var toolbarOffset = 0;

          // If we're in landscape mode and the address bar is visible, the offset needs to be negative
          if ($window.innerHeight < $window.innerWidth) {
            $stickyFooter.addClass(footerLandscapeClass);
            if ($window.innerHeight < $window.screen.availWidth) {
              toolbarOffset = TOOLBAR_HEIGHT_PX;
            }
          } else {
            $stickyFooter.removeClass(footerLandscapeClass);
            $stickyFooter.removeProp("style");
            return;
          }

          $stickyFooter.css({
            "padding-bottom": toolbarOffset + "px",
          });
        };

        var updateStickyPanels = function () {
          updateStickyInfo();
          adjustStickyFooterForIOS();
          updateStickyFooter();
        };

        $scope.pricingPage.isSpecialOffer = function () {
          return (
            !$scope.pricingPage.loading &&
            !$scope.driveawayPrice.showError() &&
            ($scope.pricingPage.isSpecialOfferFinance() || $scope.pricingPage.isSpecialOfferCash())
          );
        };

        $scope.pricingPage.isSpecialOfferFinance = function () {
          return (
            !$scope.pricingPage.loading &&
            $scope.financeOptions.showingFinance &&
            $scope.financeOptions.variables.isCampaign
          );
        };

        $scope.pricingPage.isSpecialOfferCash = function () {
          return (
            !$scope.pricingPage.loading &&
            !$scope.financeOptions.showingFinance &&
            ($scope.specialOffer.isHot || $scope.specialOffer.isCool)
          );
        };

        $scope.pricingPage.isSpecialOfferHot = function () {
          return (
            ($scope.financeOptions.showingFinance && $scope.financeCalculator.calculation.campaignType === "S") ||
            (!$scope.financeOptions.showingFinance && $scope.specialOffer.isHot)
          );
        };

        $scope.pricingPage.isSpecialOfferCool = function () {
          return (
            ($scope.financeOptions.showingFinance && $scope.financeCalculator.calculation.campaignType !== "S") ||
            (!$scope.financeOptions.showingFinance && $scope.specialOffer.isCool)
          );
        };

        updateStickyPanels();
        $scope.$on("secondary-nav-repaint", updateStickyPanels);
        angular.element($window).on("scroll resize orientationChange load", updateStickyPanels);
      };

      return {
        scope: false,
        restrict: "A",
        link: link,
      };
    },
  ]);
})(window.angular);
